@if (initialized && formGroup) {

  <div class="mx-auto">
<!--    <div class="text-center mb-6">-->
<!--      <div class="text-color text-3xl font-semibold mb-2">Benachrichtigungen</div>-->
<!--      <span class="text-color-secondary text-sm">Wir wollen, dass du immer auf dem aktuellen Stand bist. Wähle bitte aus, wie wir dich kontaktieren dürfen.</span>-->
<!--    </div>-->

    <form [formGroup]="formGroup">
      <div formArrayName="channels" *ngFor="let channelGroup of channelsFormArray; let i = index">
        <div [formGroupName]="i" class="contact-preference">
          <div class="flex justify-content-between">
            <div>
              <label class="font-medium">
                {{ channelGroup.get('uiName')?.value }}
                <span *ngIf="channelGroup.get('uiMandatory')?.value"
                      class="text-red-400 font-normal">(Erforderlich)</span>
                <i [pTooltip]="channelGroup.get('uiDescriptionHTML')?.value"
                   class="pi pi-info-circle text-color-secondary mx-2 cursor-pointer"></i>
              </label>
              <p class="pt-2">{{ channelGroup.get('uiShortDescription')?.value }}</p>
            </div>
            <div>
              <!-- Bind the input switch to the 'confirmed' FormControl -->
              <p-inputSwitch [readonly]="channelGroup.get('readOnly')?.value"
                             formControlName="confirmed"></p-inputSwitch>
            </div>
          </div>
        </div>
      </div>
    </form>


    <div class="flex justify-content-between col-12 py-4">
      <div>
      </div>

      <div>
        <!--      <p-button (click)="updateNotifications()" label="Speichern"></p-button>-->
        <app-button [busy]="busy"
                    [label]="'Speichern'"
                    [showIcon]="false"
                    (onClick)="updateNotifications()">
        </app-button>
      </div>
    </div>

  </div>

}
